module.exports = __webpack_public_path__ + "static/media/Partner1.7c40288b.webp";